import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BillingPeriod } from '@modules/product/billingPeriod';
import { NoFulfilmentOptions } from '@modules/product/fulfilmentOptions';
import { NoProductOptions } from '@modules/product/productOptions';
import { simpleFormatAmount } from 'helpers/forms/checkouts';
import { getBillingPeriodNoun } from 'helpers/productPrice/billingPeriods';
import { getProductPrice, isNumeric } from 'helpers/productPrice/productPrices';
import { getQueryParameter } from 'helpers/urls/url';
import { getSanitisedHtml } from '../utilities/utilities';
const hasDiscount = (promotion) => isNumeric(promotion?.discountedPrice);
function applyDiscount(price, promotion) {
    if (hasDiscount(promotion)) {
        return { ...price, price: promotion.discountedPrice };
    }
    return price;
}
const matchesQueryParam = (promotion) => getQueryParameter('promoCode') === promotion.promoCode;
function getAppliedPromo(promotions) {
    if (promotions && promotions.length > 0) {
        if (promotions.length > 1) {
            return promotions.find(matchesQueryParam) ?? promotions[0];
        }
        return promotions[0];
    }
    return undefined;
}
function getPromotion(productPrices, country, billingPeriod, fulfilmentOption = NoFulfilmentOptions, productOption = NoProductOptions) {
    /*
  getProductPrice can raise an Error if not available (ie Storybook)
  this try/catch wrapper ensures its returned as undefined as specified,
  getProductPrice (used throughout) safer to remain un-changed
  */
    try {
        return getAppliedPromo(getProductPrice(productPrices, country, billingPeriod, fulfilmentOption, productOption).promotions);
    }
    catch (error) {
        return undefined;
    }
}
function getSanitisedPromoCopy(promotionCopy, isGift) {
    if (!promotionCopy) {
        return {};
    }
    const msgFirstPerson = isGift ? 'their' : 'your';
    return {
        title: promotionCopy.title ?? `Open up ${msgFirstPerson} world view`,
        description: getSanitisedHtml(promotionCopy.description ?? ''),
        roundel: getSanitisedHtml(promotionCopy.roundel ?? ''),
    };
}
function promotionHTML(html, { css = '', tag = 'span' } = {}) {
    if (!html) {
        return null;
    }
    const TagName = tag;
    return (_jsx(TagName, { css: css, dangerouslySetInnerHTML: {
            __html: html,
        } }));
}
function finalPrice(productPrices, country, billingPeriod, fulfilmentOption = NoFulfilmentOptions, productOption = NoProductOptions) {
    return applyDiscount(getProductPrice(productPrices, country, billingPeriod, fulfilmentOption, productOption), getPromotion(productPrices, country, billingPeriod, fulfilmentOption, productOption));
}
const discountSummaryCopy = (currency, promoCount, price, promotion, billingPeriod) => {
    /**
     * EXAMPLE:
     * - £6/month for the first month, then £10/month
     * - £6.5/month for 6 months, then £10/month
     * - £173/year for the first year, then £275/year
     */
    const durationMonths = promotion.discount?.durationMonths ?? 0;
    const formattedPrice = simpleFormatAmount(currency, price);
    const formattedPromotionPrice = simpleFormatAmount(currency, promotion.discountedPrice ?? 0);
    const periodNoun = getBillingPeriodNoun(billingPeriod);
    const duration = billingPeriod === BillingPeriod.Annual
        ? durationMonths / 12
        : durationMonths;
    return `${formattedPromotionPrice}/${periodNoun} for ${periodNoun === 'year' || duration === 1 ? 'the first' : ''}${duration > 1 ? duration : ''} ${periodNoun}${duration > 1 ? 's' : ''}, then ${formattedPrice}/${periodNoun}${'*'.repeat(promoCount)}`;
};
export { getPromotion, getAppliedPromo, applyDiscount, hasDiscount, getSanitisedPromoCopy, promotionHTML, finalPrice, discountSummaryCopy, };
